import { ReactElement, ReactNode } from 'react';
import { useFormPageContent } from '../../state/FormPage';

export interface FormPageContentProps {
  /**
   * <MainContent> and, if needed, <AdditionalContent> elements
   */
  children: ReactNode;
}

export type FormPageContentElement = ReactElement<
  FormPageContentProps,
  typeof FormPageContent
>;

export function FormPageContent(_props: FormPageContentProps) {
  return null;
}

FormPageContent.useFormPageContent = useFormPageContent;
FormPageContent.displayName = 'FormPageContent';
